import React from 'react';
import {StickyHeader} from '.';
import {List, ListItem} from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import MuiTypography from '@new-components/atoms/MuiTypography';
import MuiBox from '@new-components/atoms/MuiBox';

type Menus = StickyHeader['destinations']['items'];
interface DestinationsMenuList {
  transparent: boolean;
  menus: Menus;
  onClick: () => void;
}

const DestinationsMenuList: React.FC<DestinationsMenuList> = React.memo(
  (props) => {
    const [current, setCurrent] = React.useState<{img: string; desc: string}>({
      img: props.menus[0]?.image ?? '',
      desc: props.menus[0]?.description ?? '',
    });

    const toggle = (val: Menus[number]) => () =>
      setCurrent({img: val.image, desc: val.description});

    return (
      <MuiBox
        sx={{
          pt: 11,
          pb: 1,
          display: 'grid',
          gap: '54px',
          gridTemplateColumns: '1fr 2fr',
        }}>
        <List
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            columnGap: '54px',
            padding: 0,
            marginTop: '-16px',
          }}>
          {props.menus.map((menu, index) => (
            <ListItem
              key={menu.label}
              onClick={props.onClick}
              onMouseOver={toggle(menu)}
              sx={{
                flex: '0 0 50%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                pl: 2,
                borderBottom: '1px solid #82807E1A',
                ['&:last-child']: {
                  borderBottom: 'none',
                },
              }}>
              <Link
                href={menu.link}
                prefetch={false}
                style={{textDecoration: 'none'}}>
                <MuiTypography
                  variant='body1'
                  sx={{
                    fontSize: '24px',
                    color: props.transparent ? '#FFFFFF' : '#FFFFFF',
                    fontWeight: '300',
                    transition: 'color 0.4s',
                    textDecoration: 'none',
                    width: 'fit-content',
                    ['&:hover']: {
                      textDecoration: 'none',
                      color: '#FFA629',
                      transition: 'color 0.3s',
                    },
                    ['&:after']: {
                      content: '""',
                      display: 'block',
                      width: '0%',
                      height: '2px',
                      background: '#FFA629',
                      marginTop: '-4px',
                      transition: 'width 0.3s',
                    },
                    ['&:hover:after']: {
                      width: '100%',
                    },
                  }}>
                  {menu.label}
                </MuiTypography>
              </Link>
            </ListItem>
          ))}
        </List>
        <MuiBox
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
          }}>
          <MuiBox
            sx={{display: 'flex', justifyContent: 'center', width: '100%'}}>
            {current && (
              <Image
                src={current.img}
                alt='destination'
                width='710'
                height='365'
                style={{
                  objectFit: 'cover',
                  borderRadius: '16px',
                }}
              />
            )}
          </MuiBox>
          <MuiBox
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              pt: 3,
              pb: 3,
              height: '100px',
            }}>
            <MuiTypography
              variant='body2'
              noWrap={false}
              gutterBottom={true}
              paragraph={true}
              sx={{
                maxWidth: '60%',
                fontSize: '16px',
                fontWeight: 300,
                lineHeight: '16.25px',
                textAlign: 'left',
                textTransform: 'none',
                color: props.transparent ? '#FFFFFFBF' : '#FFFFFFBF',
              }}>
              {current.desc}
            </MuiTypography>
          </MuiBox>
        </MuiBox>
      </MuiBox>
    );
  }
);

export default DestinationsMenuList;
export type {DestinationsMenuList};
